import { render, staticRenderFns } from "./TemplateListPhoto.vue?vue&type=template&id=3c1d060f&scoped=true"
import script from "./TemplateListPhoto.vue?vue&type=script&lang=js"
export * from "./TemplateListPhoto.vue?vue&type=script&lang=js"
import style0 from "./TemplateListPhoto.vue?vue&type=style&index=0&id=3c1d060f&prod&lang=css"
import style1 from "./TemplateListPhoto.vue?vue&type=style&index=1&id=3c1d060f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d060f",
  null
  
)

export default component.exports